const RemoveFilledIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path d='M15.8337 10.8337H4.16699V9.16699H15.8337V10.8337Z' fill='#03032E' fillOpacity='0.87' />
    </svg>
  )
}

export { RemoveFilledIcon }
